import { Guid } from "@/Common/Models/Guid";
import { InboundFaxImportanceType } from "@/Common/Models/UI/Enums";

class InboundFaxMailboxFilterSettingsModel {
    public DateFrom: Date = null;
    public DateTo: Date = null;
    public SelectedFaxNumberIds: number[] = [];
    public SelectedDocumentClassIds: (Guid | string)[] = [];
    public SelectedUrgencies: InboundFaxImportanceType[] = [];
    public QueryPageSize: number = 50;
    public IsNotAssignedChecked: boolean = false;
}

export { InboundFaxMailboxFilterSettingsModel };
